import type { ClikArtItem } from '@/api/types/clikart'
import type { PlacedImageRefs } from '../types/placed-image-refs'

/**
 * Maps a ClikArt item to StowedElement `imageElement` identifiers — the ClikArt-side counterpart
 * of `lib/photos/map-candid-to-image-refs.ts`'s `mapCandidToImageRefs`. `imageType: 'ClikArt'` is
 * the legacy app's own `IV` attribute for this same asset category — confirmed directly against
 * real legacy-authored checkpoint XML (`IV="ClikArt"` alongside `IV="Candid"`), not invented.
 * `pezId` (empty for a photo) carries the ClikArt's `artId` instead of `imageId`.
 */
export function mapClikArtToImageRefs(item: ClikArtItem): PlacedImageRefs {
  return {
    imageId: '',
    imageType: 'ClikArt',
    pezId: item.artId,
  }
}
